import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../api/axios";
import { findFirstWithLargestLanguages } from "../utils/utils";

const initialState = {
  controllerDetails: null,
  scopes: [],
  scope: "",
  scopeStatus: "idle",
  error: null,
  purposes: [],
  languages: [],
  languageStatus: "idle",
  isEnableAlias: true,
};

export const getControllerScopes = createAsyncThunk(
  "controller/getControllerScopes",
  async ({ signal, code }, thunkAPI) => {
    const response = await axiosInstance.get(`/controller/${code}`, { signal });
    return response.data;
  }
);
export const fetchLanguages = createAsyncThunk(
  "controller/fetchLanguages",
  async ({ controller, scope }) => {
    const response = await axiosInstance.get(
      `controller/${controller}/config/${scope}`
    );
    return response.data;
  }
);
export const fetchCountryLanguages = createAsyncThunk(
  "controller/fetchCountryLanguages",
  async ({ controller, scope }) => {
    const response = await axiosInstance.get(
      `/get_country/details/${controller}/${scope}`
    );
    return response.data;
  }
);

const controllerCodeSlice = createSlice({
  name: "controller",
  initialState,
  reducers: {
    setScope: (state, action) => {
      state.countryLanguages = [];
      state.countryLanguageStatus = "idle";
      state.scope = action.payload;
    },
    setScopes: (state, action) => {
      state.scopeStatus = "succeeded";
      state.scopes = action?.payload || [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getControllerScopes.pending, (state) => {
        state.scopeStatus = "loading";
      })
      .addCase(getControllerScopes.fulfilled, (state, action) => {
        state.scopeStatus = "succeeded";
        state.controllerDetails = action?.payload
        const scopeses = action?.payload?.data_processing_purpose_configurations
          ? Object.keys(action?.payload?.data_processing_purpose_configurations)
          : [];
        const sortedScopes = scopeses.sort((a, b) => a.localeCompare(b));
        state.scopes = sortedScopes;
        state.isEnableAlias = action?.payload?.enable_alias;
      })
      .addCase(getControllerScopes.rejected, (state, action) => {
        if (!(action.error.code === "ERR_CANCELED")) {
          state.scopeStatus = "failed";
          state.error = action.error.message;
          state.scopes = [];
          state.scope = "";
          state.languages = [];
          state.isEnableAlias = true;
          state.controllerDetails = null
        }
      })
      .addCase(fetchLanguages.pending, (state) => {
        state.languageStatus = "loading";
      })
      .addCase(fetchLanguages.fulfilled, (state, action) => {
        state.languageStatus = "succeeded";
        const langs =
          findFirstWithLargestLanguages(action?.payload)?.languages || [];
        state.languages = langs?.map((lang) => ({ value: lang, label: lang }));
        state.purposes = action?.payload|| [];
      })
      .addCase(fetchLanguages.rejected, (state, action) => {
        state.languageStatus = "failed";
        state.languages = [];
        state.purposes = [];
      })
      .addCase(fetchCountryLanguages.pending, (state) => {
        state.countryLanguageStatus = "loading";
        state.countryLanguages = [];
      })
      .addCase(fetchCountryLanguages.fulfilled, (state, action) => {
        state.countryLanguageStatus = "succeeded";
        const langs = action?.payload?.countryDetailsVO[0]?.languages
          ?.sort((a, b) => a?.priority - b?.priority)
          ?.map((lang) => ({
            value: lang?.languageCode,
            label: lang?.language,
          }));
        state.countryLanguages = langs;
      })
      .addCase(fetchCountryLanguages.rejected, (state, action) => {
        state.countryLanguageStatus = "failed";
        state.countryLanguages = [];
      });
  },
});
export const { setScope, setScopes } = controllerCodeSlice.actions;
export default controllerCodeSlice.reducer;

let currentAbortController = null;

export const fetchControllerScopes = (code) => (dispatch) => {
  if (currentAbortController) {
    currentAbortController.abort();
  }
  currentAbortController = new AbortController();

  return dispatch(
    getControllerScopes({
      code,
      signal: currentAbortController.signal,
    })
  );
};